export default {
    init() {
        this.ListsActionsToggle();
        this.TextEditor();
        this.upload1Image();
        this.DragAndDrop1ImageUpload();
        this.uploadMultiImage();
        this.uploadMultiEdit();
        this.tableTabToggle();
        this.rulesFormToggle();
        this.subSelectDrop();
        this.tablePaginationInput();
        this.dateRangePicker();
        this.reorderTable();
        this.popupMain();
    },


    ListsActionsToggle() {
        let moreActionsBtn = $('.column.actions .actions-more');

        moreActionsBtn.on('click', function (e) {
            e.preventDefault();

            let thisDrop = $(this).parent().find('.actions-drop');
            let drops = $('.actions-drop');
            drops.removeClass('current');
            thisDrop.addClass('current');

            let dropdowns = $('.actions-drop:not(.current)');
            dropdowns.removeClass('active');

            thisDrop.toggleClass('active');
        });

        let dropdowns = $('.actions-drop');

        $('body').on('click', function (e) {
            if (!moreActionsBtn.is(e.target) && moreActionsBtn.has(e.target).length === 0 && !dropdowns.is(e.target) && dropdowns.has(e.target).length === 0) {
                dropdowns.removeClass('active');
            }
        });
    },

    TextEditor() {
        // document.addEventListener("DOMContentLoaded", function (event) {
        //  //const Quill = require("quill");
        //     $('.text-editor').each(function (index) {
        //         let el = $(this).get(0);
        //         new Quill(el, {
        //             theme: 'snow',
        //             modules: {
        //                 // toolbar: [
        //                 //     ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        //                 //     ['blockquote', 'code-block'],
        //                 //
        //                 //     [{'header': 1}, {'header': 2}],               // custom button values
        //                 //     [{'list': 'ordered'}, {'list': 'bullet'}],
        //                 //     [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
        //                 //     [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
        //                 //     [{'direction': 'rtl'}],                         // text direction
        //                 //
        //                 //     [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
        //                 //     [{'header': [1, 2, 3, 4, 5, 6, false]}],
        //                 //
        //                 //     [{'color': []}, {'background': []}],          // dropdown with defaults from theme
        //                 //     [{'font': []}],
        //                 //     [{'align': []}],
        //                 //     ['link', 'image'],
        //                 // ]
        //             },
        //         });
        //     });
        // });
    },

    upload1Image() {
        const self = this;
        let fileTypes = ['jpg', 'jpeg', 'png'];
        let maxAllowedSize = 30 * 1024 * 1024;
        let importFileInput = $('.form-photo-upload-wrap .import-file');

        importFileInput.on('change', function () {
            let importParent = $(this).parent().parent();
            let wrongFile = importParent.find('.wrong-file-type');
            let uploadArea = importParent.find('.form-photo-upload-wrap--upload-box');
            let filesList = importParent.find('.form-photo-upload-wrap--list');


            if ($(this)[0].files.length > 0) {
                uploadArea.removeClass('invalid');
                let filesAllowed = [];
                let countInvalid = false;
                let files = $(this)[0].files;

                for (let i = 0; i < files.length; i++) {
                    if (files[i].size < maxAllowedSize) {
                        let extension = files[i].name.split('.').pop().toLowerCase();
                        let isSuccess = fileTypes.indexOf(extension) > -1;
                        if (isSuccess) {
                            filesAllowed.push(files[i]);
                        } else {
                            countInvalid = true;
                        }
                    } else {
                        countInvalid = true;
                    }
                }

                if (filesAllowed.length >= 1) {
                    uploadArea.addClass('active');
                    uploadArea.find('.text').text('Upload new photo');
                }

                var oFReader = new FileReader();
                for (let i = 0; i < filesAllowed.length; i++) {
                    oFReader.readAsDataURL(filesAllowed[i]);
                    oFReader.onload = function (oFREvent) {
                        let numberOfChildren = filesList.children().length;
                        if (numberOfChildren < 30) {
                            filesList.html(' <li class="item"><img src="' + oFREvent.target.result + '" alt=""></li>');
                        }
                    }
                }



                if (countInvalid == true) {
                    uploadArea.addClass('invalid');
                    wrongFile.slideDown(300);
                } else {
                    wrongFile.slideUp(300);
                    uploadArea.removeClass('invalid');
                }
            }
        });
    },

    DragAndDrop1ImageUpload() {
        const self = this;
        let fileTypes = ['jpg', 'jpeg', 'png'];
        let maxAllowedSize = 30 * 1024 * 1024;
        let wrongFile = $('.form-photo-upload-wrap .wrong-file-type');
        let uploadArea = $('.form-photo-upload-wrap .form-photo-upload-wrap--upload-box');
        let filesList = $('.form-photo-upload-wrap .form-photo-upload-wrap--list');
        let importFileInput = $('.form-photo-upload-wrap .import-file');
        let explorerCheck = false;
        let safariCheck = false;

        if (navigator.userAgent.indexOf('Trident/') !== -1) {
            explorerCheck = true;
        } else {
            explorerCheck = false;
        }

        if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
            safariCheck = true;
        } else {
            safariCheck = false;
        }

        function preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        }

        function highlight() {
            uploadArea.addClass('hover');
        }

        function dropFiles(e) {
            uploadArea.removeClass('hover');

            //If delete previous import
            //filesList.empty();

            let filesAllowed = [];
            let files = e.dataTransfer.files;
            let countInvalid = false;

            for (let i = 0; i < files.length; i++) {
                if (files[i].size < maxAllowedSize) {
                    let extension = files[i].name.split('.').pop().toLowerCase();
                    let isSuccess = fileTypes.indexOf(extension) > -1;
                    if (isSuccess) {
                        filesAllowed.push(files[i]);
                    } else {
                        countInvalid = true;
                    }
                } else {
                    countInvalid = true;
                }
            }

            if (countInvalid == true) {
                uploadArea.addClass('invalid');
                wrongFile.slideDown(300);
            } else {
                wrongFile.slideUp(300);
                uploadArea.removeClass('invalid');
            }

            generateFileList(filesAllowed);
            document.querySelector('.form-photo-upload-wrap--upload-box .import-file').files = new FileListItem(filesAllowed);
        }

        function generateFileList(files) {
            if (files.length >= 1) {
                uploadArea.addClass('active');
                uploadArea.find('.text').text('Upload new photo');
            }
            for (let file of files) {
                let numberOfChildren = filesList.children().length;
                if (numberOfChildren < 30) {
                    filesList.append(`<div class="item">"${file.name}" <span data-name="${file.name}"></span></div>`);
                }
            }
        }

        function FileListItem(a) {
            a = [].slice.call(Array.isArray(a) ? a : arguments)
            for (var c, b = c = a.length, d = !0; b-- && d;) d = a[b] instanceof File
            if (!d) throw new TypeError("expected argument to FileList is File or array of File objects")
            for (b = (new ClipboardEvent("")).clipboardData || new DataTransfer; c--;) b.items.add(a[c])
            return b.files
        }
    },

    uploadMultiImage() {
        const self = this;
        let fileTypes = ['jpg', 'jpeg', 'png'];
        let maxAllowedSize = 30 * 1024 * 1024;
        let importFileInput = $('.form-photo-upload-wrap.multi .import-file');

        importFileInput.on('change', function () {
            let importParent = $(this).parent().parent();
            let wrongFile = importParent.find('.wrong-file-type');
            let uploadArea = importParent.find('.form-photo-upload-wrap--upload-box');
            let filesList = importParent.closest('.form-photo-upload-multi-row').find('.form-photo-upload-wrap--list.multi');


            if ($(this)[0].files.length > 0) {
                uploadArea.removeClass('invalid');
                let filesAllowed = [];
                let countInvalid = false;
                let files = $(this)[0].files;

                for (let i = 0; i < files.length; i++) {
                    if (files[i].size < maxAllowedSize) {
                        let extension = files[i].name.split('.').pop().toLowerCase();
                        let isSuccess = fileTypes.indexOf(extension) > -1;
                        if (isSuccess) {
                            filesAllowed.push(files[i]);
                        } else {
                            countInvalid = true;
                        }
                    } else {
                        countInvalid = true;
                    }
                }

                for (let i = 0; i < filesAllowed.length; i++) {
                    var oFReader = new FileReader();
                    oFReader.onload = function (oFREvent) {
                        let numberOfChildren = filesList.children().length;
                        if (numberOfChildren < 30) {
                            filesList.append(' <li class="item"><img src="' + oFREvent.target.result + '" alt=""><button class="upload-item-delete"><icon></icon></button></li>');
                        }
                    }
                    oFReader.readAsDataURL(filesAllowed[i]);
                }

                if (countInvalid == true) {
                    uploadArea.addClass('invalid');
                    wrongFile.slideDown(300);
                } else {
                    wrongFile.slideUp(300);
                    uploadArea.removeClass('invalid');
                }

                $('.form-photo-upload-wrap--list').sortable({
                    revert: true,
                    connectWith: "ul",
                    forcePlaceholderSize: true,
                    stop: function( event, ui ) { ui.item.removeAttr("style");}
                });

                $( ".form-photo-upload-wrap--list" ).disableSelection();

            }
        });
    },

    uploadMultiEdit(){
        $('.form-photo-upload-wrap--list').sortable({
            revert: true,
            connectWith: "ul",
            forcePlaceholderSize: true,
            stop: function( event, ui ) { ui.item.removeAttr("style");}
        });

        $( ".form-photo-upload-wrap--list" ).disableSelection();

        $('body').on('click', '.form-photo-upload-wrap--list.multi .upload-item-delete',function(){
            $(this).parent().remove();
        });
    },

    tableTabToggle() {
        $('.tab-tables-block.hidden-tab').hide();
        $('.tab-tables-nav li').on('click', function () {
            let loader = $(this).closest('.tab-tables').find('.loader-holder');
            loader.show();
            if (!$(this).hasClass('active')) {
                loader.show();
                $(this).parent().find('li').removeClass('active');
                $(this).addClass('active');
                let link = $(this).data( "link");
                $(this).closest('.tab-tables').find('.tab-tables-block').addClass('hidden-tab');
                $(this).closest('.tab-tables').find('.tab-tables-block').hide();
                $(this).closest('.tab-tables').find('.tab-tables-block[data-link="'+link+'"]').removeClass('hidden-tab');
                $(this).closest('.tab-tables').find('.tab-tables-block[data-link="'+link+'"]').show();
                setTimeout(function () {
                    loader.fadeOut(300);
                }, 300);
            };
        });
    },

    rulesFormToggle(){
        if ($('.rules-tab-check').find('input').is(':checked')) {
            $('.rules-tab').show();
        } else {
            $('.rules-tab').hide();
        }

        $('.rules-tab-check').on('click', function(){
            if ($(this).find('input').is(':checked')) {
                $('.rules-tab').slideDown(300);
            } else {
                $('.rules-tab').slideUp(300);
            }
        });
    },

    subSelectDrop(){
        let subSelect = $('.sub-select .select2');
        if (subSelect.length > 0) {
            subSelect.select2({dropdownAutoWidth: true, width: 'resolve'});
        }
    },

    tablePaginationInput() {
        $('.pagination-input .pages-control i').on('click', function () {
            let paginationInput = $('.pagination-input input');
            if ($(this).hasClass('up')) {
                paginationInput.val(parseInt(paginationInput.val()) + 1);
            } else {
                paginationInput.val(parseInt(paginationInput.val()) - 1);
            }

            if (paginationInput.val() < 1) {
                paginationInput.val(1);
            }
        });
    },

    dateRangePicker(){
        $(".calendar-view-btn").daterangepicker({
            forceUpdate: true,
            singleDatePicker: true,
            showDropdowns: true,
            autoApply: true,
            locale: {
                format: 'YYYY-MM-DD'
            }
        });

        $(".calendar-start-input-date").daterangepicker({
            forceUpdate: false,
            autoUpdateInput: false,
            singleDatePicker: true,
            showDropdowns: true,
            autoApply: true,
            locale: {
                format: 'YYYY-MM-DD'
            }
        });

        $(".calendar-end-input-date").daterangepicker({
            forceUpdate: false,
            autoUpdateInput: false,
            singleDatePicker: true,
            showDropdowns: true,
            autoApply: true,
            locale: {
                format: 'YYYY-MM-DD'
            }
        });

        $(".input-daterange-select").daterangepicker({
            forceUpdate: true,
            singleDatePicker: true,
            showDropdowns: true,
            autoApply: true,
            locale: {
                format: 'YYYY-MM-DD'
            }
        });
    },


    reorderTable(){
        $('.reorder-table').sortable({
            items: 'tr',
            cursor: 'pointer',
            axis: 'y',
            // start: function (e, ui) {
            //     ui.item.addClass("selected");
            // },
            // stop: function (e, ui) {
            //     ui.item.removeClass("selected");
            //     $(this).find("tr").each(function (index) {
            //         if (index > 0) {
            //             $(this).find("td").eq(2).html(index);
            //         }
            //     });
            // }

        });
    },

    popupMain(){
        $('.pop-up-close').on('click', function(){
            $(this).closest('.pop-up').parent().fadeOut();
        });
        $('.close-pop').on('click', function(){
            $(this).closest('.pop-up').parent().fadeOut();
        });
    },
}